export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7790.defa34a3.jpg";